// client/src/pages/CreateLobby.jsx
import React from 'react';
import { useLobbyCreateController } from '../controllers/useLobbyCreateController.js';

function LobbyCreate() {
    const {
        userName,
        setUserName,
        password,
        setPassword,
        isPrivate,
        setIsPrivate,
        handleCreateLobby,
        navigate
    } = useLobbyCreateController();

    return (
        <div className="container">
            <div className="box">
                <div className="page-icon-header">
                    <div className="page-icon page-icon--create">
                        <i className="fas fa-plus" />
                    </div>
                </div>
                <h2>Lobby erstellen</h2>
                <div className="page-divider">
                    <span className="page-divider-line" />
                    <span className="page-divider-diamond" />
                    <span className="page-divider-line" />
                </div>

                <div className="form-group">
                    <label htmlFor="username">Dein Name</label>
                    <input
                        id="username"
                        type="text"
                        placeholder="Spielername eingeben"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                </div>

                <div
                    className={`password-option ${isPrivate ? 'active' : ''}`}
                    onClick={() => setIsPrivate(!isPrivate)}
                >
                    <i className={`fas ${isPrivate ? 'fa-lock' : 'fa-lock-open'}`} style={{ marginRight: 8 }} />
                    Private Lobby
                </div>

                {isPrivate && (
                    <div className="form-group" style={{ marginTop: '1rem' }}>
                        <label htmlFor="lobbypassword">Passwort</label>
                        <input
                            id="lobbypassword"
                            placeholder="Lobby-Passwort festlegen"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                )}

                <div className="button-group">
                    <button
                        onClick={handleCreateLobby}
                        className="button button-primary"
                        disabled={isPrivate && !password}
                    >
                        <i className="fas fa-plus" /> Erstellen
                    </button>
                    <button type="button" className="button button-secondary" onClick={() => navigate('/')}>
                        <i className="fas fa-arrow-left" /> Zurück
                    </button>
                </div>
            </div>
        </div>
    );
}

export default LobbyCreate;
